var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TheBanner',{attrs:{"title":this.$lang.supportTitle,"description":this.$lang.supportSubtitle,"image":"cover.jpeg"}}),_c('GridView',{staticClass:"body-block",attrs:{"id":"grid","size":"155px","data":_vm.gridData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }